import { Instagram, Facebook, Music2, Ghost, MessageCircle } from "lucide-react";
import { SOCIALS } from "@/lib/constants";

const ICONS = {
  instagram: Instagram,
  facebook: Facebook,
  tiktok: Music2,
  snapchat: Ghost,
  whatsapp: MessageCircle,
};

export const SocialIcon = ({ icon, className = "w-5 h-5" }) => {
  const Icon = ICONS[icon] || MessageCircle;
  return <Icon className={className} />;
};

export default function SocialLinks({ className = "", itemClass = "" }) {
  return (
    <div className={`flex flex-wrap gap-3 ${className}`}>
      {SOCIALS.map((s) => (
        <a
          key={s.platform}
          data-testid={`social-link-${s.icon}`}
          href={s.url}
          {...(s.url.startsWith("/") ? {} : { target: "_blank", rel: "noopener noreferrer" })}
          aria-label={s.label}
          title={s.label}
          className={`w-12 h-12 rounded-full border border-white/15 bg-white/5 flex items-center justify-center text-zinc-300 hover:text-white hover:border-[#FF1E27] hover:bg-[#FF1E27]/10 transition-colors duration-300 ${itemClass}`}
        >
          <SocialIcon icon={s.icon} />
        </a>
      ))}
    </div>
  );
}
